import Col from "antd/lib/col"
import Row from "antd/lib/row"
import React from "react"
import config from "react-global-configuration"
import { useLocation, useNavigate } from "react-router"

import { cdn } from "core/cdn"
import { PROFILE_PAGE, VERIFY_PAGE } from "core/constants"
import { Customer, Relative } from "types/entity"

import styles from "./Header.module.scss"
import { languages } from "lib/languages"

const Header: React.FC<{ patient?: Customer | Relative, isPatientVerified?: boolean }> = ({ patient, isPatientVerified }): JSX.Element => {
  const location = useLocation()
  const navigate = useNavigate()
  const doNotdisplayUserProfile = [VERIFY_PAGE, PROFILE_PAGE].includes(
    location.pathname
  )

  const demoVersion = window.location.hostname === localStorage.getItem("DEMO_HOSTNAME") || window.location.hostname === 'ophtalmo.medadom-demo.com';

  return (
    <Row>
      <Col span={10}></Col>
      <Col span={4} style={{ textAlign: "center" }}>
        {isPatientVerified && !doNotdisplayUserProfile && (
          <span
            onClick={() => navigate(PROFILE_PAGE)}
            className={styles.ProfileLink}
          >
            <img height="30px" src={cdn("/images/people_picto.svg")} alt="" />
            <span className={styles.Nowrap}>
              {patient.firstname} {patient.lastname}
            </span>
          </span>
        )}
        {
          (!isPatientVerified || doNotdisplayUserProfile) && demoVersion && (
            <span className={styles.demoLogo}>
              {languages.demoVersion}
            </span>
          )}
      </Col>
      {
        isPatientVerified && !doNotdisplayUserProfile && demoVersion && (
          <>
            <Col span={1}></Col>
            <Col span={5}>
              <span className={styles.demoLogo}>
                {languages.demoVersion}
              </span>
            </Col>
            <Col span={3}></Col>
          </>
        )
      }
      {(((!isPatientVerified || doNotdisplayUserProfile) && demoVersion) || !demoVersion) && <Col span={5}></Col>}
      <Col span={5} style={{ textAlign: "right" }}>
        Support : {config.get("support")}
      </Col>
    </Row>
  )
}

export default Header
